export default [
  {
    path: "/",
     text: "Home",
    },
  {
    path: "/projects",
    text: "My Work",
  },
  {
    path: "/about",
    text: "About",
  },
  {
    path: "/contact",
    text: "Contact",
  },
  
  
  
]
